import { useEffect } from "react"
import { isBrowser } from "../util"

export default function useClickObserver(ref, enabled, callback) {
  useEffect(() => {
    function checkContainment(e) {
      if (!ref.current.contains(e.target)) callback()
    }
    if (isBrowser && enabled) {
      document.body.addEventListener("mousedown", checkContainment, false)
      document.body.addEventListener("touchend", checkContainment, false)
      return () => {
        document.body.removeEventListener("mousedown", checkContainment, false)
        document.body.removeEventListener("touchend", checkContainment, false)
      }
    }
  }, [ref, callback, enabled])
}
